/*
 * File: user.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */
import { getSession, setSession, setCookie } from '@/utils';
import {
  USER_SET_AUTO_LIST,
  USER_SET_NEW_AUTO_TYPE,
  USER_SER_CURRENT_USER,
  AUTH_IS_SET_MENU,
  SET_BRAND,
  SET_BRAND_LIST,
  SET_FLAG_GET_AUTH_LIST,
  SET_TOP_MENU_LIST,
  SET_INDIE_APPS_LIST,
  SET_INTEGRAL_MALL_INFO
} from '../mutation-types';

// 状态
const state = {
  // 用户菜单
  authList: null,
  // 当前权限身份
  newAutoType: '',
  // 当前登录用户信息
  user: null,
  // 是否已经设置过权限菜单
  isHadSetMenu: false,
  // brand 品牌
  brand: null,
  // 品牌列表
  brandList: [],
  // 是否已经请求过权限菜单
  isGetAuthList: false,
  // 顶部菜单权限列表
  topMenuList: [],
  // 独立应用列表
  indieApps: []
};

// 操作
const mutations = {
  // 设置用户菜单
  [USER_SET_AUTO_LIST](state, array) {
    state.authList = array;
    setSession('authList', array);
  },
  // 当前权限身份
  [USER_SET_NEW_AUTO_TYPE](state, obj) {
    state.newAutoType = obj;
    setSession('newAutoType', obj);
  },
  // 当前登录用户信息
  [USER_SER_CURRENT_USER](state, obj) {
    state.user = obj;
    setSession('user', obj);
  },
  // 是否已经设置过权限菜单
  [AUTH_IS_SET_MENU](state, boolean) {
    state.isHadSetMenu = boolean;
    setSession('isHadSetMenu', boolean);
  },
  // brand 品牌
  [SET_BRAND](state, number) {
    state.brand = number;
    setSession('brand', number);
  },
  // brand 品牌列表
  [SET_BRAND_LIST](state, array) {
    state.brandList = array;
    setSession('brandList', array);
  },
  // isGetAuthList 是否已经请求过权限菜单
  [SET_FLAG_GET_AUTH_LIST](state, array) {
    state.isGetAuthList = array;
    setSession('isGetAuthList', array);
  },
  // 顶部菜单权限列表
  [SET_TOP_MENU_LIST](state, array) {
    state.topMenuList = array;
    setSession('topMenuList', array);
  },
  // 独立应用
  [SET_INDIE_APPS_LIST](state, array) {
    state.indieApps = array;
    setSession('indieApps', array);
  },
  // 清除积分商城后台登录信息
  [SET_INTEGRAL_MALL_INFO]() {
    setCookie('loginToken', '', -1, '/', '.midea.com');
    setCookie('uaccount', '', -1, '/', '.midea.com');
    setCookie('uname', '', -1, '/', '.midea.com');
  },
};

// 方法
const actions = {
  // 设置用户菜单
  setAuthMenu({ commit }, authList) {
    commit('USER_SET_AUTO_LIST', authList);
  },
  // 当前权限身份
  setNewAutoTpye({ commit }, newAutoType) {
    commit('USER_SET_NEW_AUTO_TYPE', newAutoType);
  },
  // 当前登录用户信息
  setCurrentUser({ commit }, user) {
    commit('USER_SER_CURRENT_USER', user);
  },
  // 是否已经设置过权限菜单
  setIsAuthMenu({ commit }, isHadSetMenu) {
    commit('AUTH_IS_SET_MENU', isHadSetMenu);
  },
  // brand 品牌
  setBrand({ commit }, brand) {
    commit('SET_BRAND', brand);
  },
  // brand 品牌列表
  setBrandList({ commit }, brandList) {
    commit('SET_BRAND_LIST', brandList);
  },
  // isGetAuthList 是否已经请求过权限菜单
  flagGetAuthList({ commit }, isGetAuthList) {
    commit('SET_FLAG_GET_AUTH_LIST', isGetAuthList);
  },
  // 顶部菜单权限列表
  setTopMenuList({ commit }, topMenuList) {
    commit('SET_TOP_MENU_LIST', topMenuList);
  },
  // 独立应用
  setIndieApps({ commit }, indieApps) {
    commit('SET_INDIE_APPS_LIST', indieApps);
  },
  // 当退出登录的时候，清除所有的用户数据
  logoutClearUserInfo({ commit }) {
    // 是否已经请求过权限菜单
    commit('SET_FLAG_GET_AUTH_LIST', false);
    // 品牌列表
    commit('SET_BRAND_LIST', []);
    // 品牌
    commit('SET_BRAND', null);
    // 是否已经设置过权限菜单,退出刷新的时候，重置
    // commit('AUTH_IS_SET_MENU', false);
    // 当前登录用户信息
    commit('USER_SER_CURRENT_USER', null);
    // 当前权限身份
    commit('USER_SET_NEW_AUTO_TYPE', '');
    // 设置用户菜单
    commit('USER_SET_AUTO_LIST', null);
    // 顶部菜单权限列表
    commit('SET_TOP_MENU_LIST', []);
    // 独立应用
    commit('SET_INDIE_APPS_LIST', []);
    // 积分商城登录信息
    commit('SET_INTEGRAL_MALL_INFO', null);
  },
  // 只是重置权限菜单按钮数据，切换品牌，换权限组用
  initMenuAuth({ commit }) {
    // 是否已经设置过权限菜单
    commit('AUTH_IS_SET_MENU', false);
    // 设置用户菜单
    commit('USER_SET_AUTO_LIST', null);
    // 顶部菜单权限列表
    commit('SET_TOP_MENU_LIST', []);
    // 独立应用
    commit('SET_INDIE_APPS_LIST', []);
  },
};

const getters = {
  // 用户菜单
  authList: state => state.authList || getSession('authList'),
  // 当前权限身份
  newAutoType: state => state.newAutoType || getSession('newAutoType'),
  // 当前登录用户信息
  user: state => state.user || getSession('user'),
  // 是否已经设置过权限菜单
  isHadSetMenu: state => state.isHadSetMenu,
  // brand 品牌
  brand: state => state.brand || getSession('brand'),
  // brand 品牌列表
  brandList: state => state.brandList || getSession('brandList'),
  // isGetAuthList 是否已经请求过权限菜单
  isGetAuthList: state => state.isGetAuthList || getSession('isGetAuthList'),
  // 顶部菜单权限列表
  topMenuList: state => state.topMenuList || getSession('topMenuList'),
  // 独立应用
  indieApps: state => state.indieApps || getSession('indieApps'),
};

export default {
  // 开启命名空间
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
